function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Oval 2");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "FINAL",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "DETAILSEITE-Copy",
  transform: "translate(-743.000000, -703.000000)",
  fill: "#4A4A4A"
}, React.createElement("circle", {
  id: "Oval-2",
  cx: 745.5,
  cy: 705.5,
  r: 2.5
})));

var SvgDot = function SvgDot(props) {
  return React.createElement("svg", _extends({
    width: "5px",
    height: "5px",
    viewBox: "0 0 5 5"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/dot.b150e7ec.svg";
export { SvgDot as ReactComponent };